export interface AIProps {
  id: string;
  description: string;
  owner?: string;
  owner_firstname?: string;
  owner_lastname?: string;
  rag?: number;
  state?: number;
  priority?: number;
  start_date?: number;
  due_date?: number;
  attachCount?: number;
  commentCount?: number;
  loopCount: number;
  subCount?: any;
  board?: number;
  board_column?: number;
  tagCount?: number;
  dueDateText?: string;
  parent?: any;
  relationshipsCount?: number;
  type?: number | string;
}

export interface IAICardProps {
  card: AIProps;
  onClick?: void;
  columnId: string;
  index?: number;
  memberHighlightedId?: string;
  highlightedAI?: boolean;
  isActive?: boolean;
  user?: any;
  wsPermissions?: any;
  showIssueTypeIcon?: boolean;
  highlightIssuesByType?: boolean;
}

export enum ActivityIssueTypes {
  ActionItem = 0,
  Risk = 1,
  Assumption = 2,
}

export enum EAiIssueTypeAttrNames {
  STATE = 'state',
  RAG = 'rag',
  EFFORT = 'effort',
  PRIORITY = 'priority',
}

export enum EState {
  Done = 0,
  Doing = 1,
  Next = 2,
  Paused = 4,
}
// dont change the values since the values are same as table column name
export const ACTIVITY_TYPE_ATTR_NAMES = ['state', 'rag', 'priority', 'effort'];
